import { StorageManager } from '../../../../common/storage-manager.class';
import { environment } from '../../../../../environments/environment';

export class AnalisisEnvironmentDefinition {
    public hasClients = environment.features.hasClients;

    public hasFincas = environment.features.hasFincas;

    public clienteName = environment.features.clienteName;

    public showAnalisisParcelas = environment.features.showAnalisisParcelas;

    public fincaName = environment.features.fincaName;

    public fincasName = environment.features.fincasName;

    public parcelaName = environment.features.parcelaName;

    public parcelasName = environment.features.parcelasName;

    public sectorName = environment.features.sectorName;

    public sectoresName = environment.features.sectoresName;

    public showAnalisisBoletin = environment.features.showAnalisisBoletin;

    public showAnalisisNumeroAnalisis = environment.features.showAnalisisNumeroAnalisis;

    public appName: string = environment.appName;

    public applicationType = environment.features.applicationType;

    public showAnalisisM3Agua = environment.features.showAnalisisM3Agua;

    public showAnalisisMgrl = environment.features.showAnalisisMgrl;

    public showCultivosBajoAguaFields = environment.features.showCultivosBajoAguaFields;
    
    public isAdmin = (StorageManager.getUser().rol === 'admin');

    public rol = StorageManager.getUser().rol;

    public textoSuperficie = environment.features.textoSuperficie;

    public serverUrl = environment.serverUrl;
    
    public showAnalisisSectorParcelas = environment.features.showAnalisisSectorParcelas;

    public clienteActual = StorageManager.getClient();

    public showAnalisisSectorParcelasForm = environment.features.showAnalisisSectorParcelas;
}// class;